// ------------------------------------
// Cupom de desconto
// ------------------------------------
(function () {
  'use strict';
  // Variáveis
  const $couponInput = $('#co-coupon');
  const $couponBtn = $('.btn-coupon');
  const $couponSuccess = $('.coupon-success');
  const $couponRemove = $('.co-resume-coupon-rem');
  const customerEmail = $('#co-email');
  const $couponError = $('.coupon-error');
  const urlApi = urlBase + 'core/acoes/checkout/valida_cupom.php';
  const urlApiRemove = urlBase + 'core/acoes/checkout/remove_cupom.php';
  let coupon;
  let customerEmailVer;

  // Ao alterar o cupom
  $couponInput.on('keyup', function (ev) {
    ev.preventDefault();
    if (ev.keyCode === 13) {
      handleCoupon();
    }
  });
  $couponInput.on('keydown', function (event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleCoupon();
    }
  });
  $couponBtn.on('click popup-apply', function (ev) {
    ev.preventDefault();
    handleCoupon();
  });
  if ($couponInput.data('coupon')) {
    const couponSaved = $couponInput.data('coupon');
    if (couponSaved.coupon && couponSaved.status === 'valid') {
      $couponInput.val(couponSaved.coupon).trigger('fl-checkval');
      $couponRemove.removeClass('d-none');
      saveCoupon(couponSaved, false);
    }
  }
  function handleCoupon() {
    if (!previewMode) {
      coupon = $couponInput.val().trim();
      if (coupon) {
        $couponError.hide();
        getCoupon(coupon);
      } else {
        $couponError.find('li').text('Digite o código do cupom.');
        $couponError.show();
      }
    }
  }

  // Aplica o cupom quando informar o e-mail
  customerEmail.on('change', function () {
    // Verifica se o campo de e-mail e cupom possuem valores
    if (customerEmail.val() && $couponInput.val()) {
      $('.btn-coupon').trigger('popup-apply');
    }
  });

  // Verifica se há o parâmetro de cupom na url e aplica automaticamente
  $(window).on('load', function () {
    if (getUrlParam('coupon') && getUrlParam('coupon') != '') {
      $couponInput.val(getUrlParam('coupon')).trigger('change');
      $('.btn-coupon').trigger('popup-apply');
    }
  });

  // Aplica o cupom
  function getCoupon(coupon) {
    $couponInput.prop('readonly', true);
    customerEmailVer = customerEmail.val();
    $couponBtn.prop('disabled', true).addClass('btn-loader').text('');
    $couponSuccess.addClass('d-none');
    $couponRemove.addClass('d-none');
    $.getJSON(
      `${urlApi}?coupon=${coupon}&store_token=${storeToken}&cart_token=${cartToken}&product=${productUrl}&has_kit=${hasKit}&has_variant=${hasVariant}&customer_email=${customerEmailVer}&storeId=${baseLanding}&lp_type=${storeModel}`,
      function (result) {
        console.log(result);
        if (result.status === 'valid') {
          $couponSuccess.removeClass('d-none');
          setTimeout(() => {
            $couponSuccess.addClass('d-none');
            $couponRemove.removeClass('d-none');
          }, 3000);
          saveCoupon(result);
        } else {
          if (result.status === 'email_empty') {
            $couponError.find('li').text('É necessário informar seu e-mail para utilizar este cupom.');
          } else {
            $couponError.find('li').text('O cupom informado é inválido.');
          }
          $couponError.show();
          saveCoupon(result);
        }
        $couponInput.prop('readonly', false);
        $couponBtn.prop('disabled', false).removeClass('btn-loader').text('Aplicar');
      },
    ).fail(function (qXHR, textStatus, errorThrown) {
      console.log(qXHR);
      $couponInput.prop('readonly', false);
      $couponBtn.prop('disabled', false).removeClass('btn-loader').text('Aplicar');
    });
  }

  // Salva o cupom
  function saveCoupon(result, reloadShip = true) {
    $('#co-coupon-input').val(coupon);
    saveOption('coupoun_desc', coupon);
    saveOption('coupoun_type', result.type);
    saveOption('coupoun_val', result.value);
    saveOption('coupoun_restricted_prods', result.restricted_prods);
    saveOption('coupoun_restricted_amount', result.restricted_amount);
    if (result.free_shipping == 1) {
      saveOption('shipping_way_price', 0);
      saveOption('free_shipping', 1);
    } else {
      saveOption('free_shipping', 0);
    }
    if (reloadShip) {
      //$('#co-zipcode').trigger('change-coupon');
      $('.shipping_ways').trigger('change-cart');
      console.log('Save from: coupon');
      saveCheckout('save', {}, calcCheckout);
    } else {
      calcCheckout();
    }
  }

  // Remove o cupom
  $couponRemove.on('click', removeCoupon);
  function removeCoupon() {
    $couponInput.prop('readonly', true);
    $couponBtn.prop('disabled', true).addClass('btn-loader').text('');
    $.getJSON(
      `${urlApiRemove}?store_token=${storeToken}&cart_token=${cartToken}&storeId=${baseLanding}&lp_type=${storeModel}&cart_id=${cartInfos?.cart_general_infos?.id}`,
      function (result) {
        console.log(result);
        $couponInput.prop('readonly', false);
        $couponBtn.prop('disabled', false).removeClass('btn-loader').text('Aplicar');
        if (result.status === 'success') {
          $couponRemove.addClass('d-none');
          $couponInput.val('');
          saveOption('coupoun_desc', '');
          saveOption('coupoun_type', '');
          saveOption('coupoun_val', '');
          saveOption('coupoun_restricted_prods', '');
          saveOption('coupoun_restricted_amount', '');
          saveOption('shipping_way_price', '');
          saveOption('free_shipping', '');
          $('.shipping_ways').trigger('change-cart');
          console.log('Save from: coupon remove');
          saveCheckout('save', {}, calcCheckout);
        }
      },
    ).fail(function (qXHR, textStatus, errorThrown) {
      console.log(qXHR);
      $couponInput.prop('readonly', false);
      $couponBtn.prop('disabled', false).removeClass('btn-loader').text('Aplicar');
    });
  }
})();

// ------------------------------------
// Popup primeira compra
// ------------------------------------
(function () {
  // Exibe popup
  setTimeout(() => {
    if (
      !previewMode &&
      $('#popup-cupom-1c').length &&
      $('#co-coupon').length &&
      !localStorage.getItem('popup-coupon-close') &&
      !$('#co-coupon').val()
    ) {
      modalOpen('popup-cupom-1c');
    }
  }, 1000);

  // Aplica o cupom
  $('.modal-popup-cupom-1c-btn').on('click', function (ev) {
    ev.preventDefault();
    if (!previewMode) {
      const coupon = $(this).data('coupon');
      $('#co-coupon').val(coupon).trigger('change');
      $('.btn-coupon').trigger('popup-apply');
      modalClose('popup-cupom-1c');
    }
  });

  // Cancela popup (Sem interesse)
  $('.modal-popup-cupom-1c-btn-cancel').on('click', function (ev) {
    ev.preventDefault();
    if (!previewMode) {
      localStorage.setItem('popup-coupon-close', '1');
    }
    modalClose('popup-cupom-1c');
  });
})();
